import React from 'react';
import ServiceTypes from '../../components/ServiceTypes';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';
import serviceTypesData from '../../data/serviceTypes.json';

const AssaultAndPropertyDamage = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Assault & Property Damage</div>
        <div className="body">
          <ServiceDescriptionSection
            content="Assault and property damage are criminal offences in Victoria that carry serious penalties, ranging from fines to imprisonment. These offences can arise from various situations, from minor altercations to significant acts of violence or vandalism. Understanding the legal implications of these crimes and the potential defences is essential for anyone facing such charges."
          />
          <ServiceTypes
            header="Types of Assault"
            preamble="Assault refers to intentionally or recklessly causing physical harm or the fear of harm to another person. There are different categories of assault in Victoria, each carrying different penalties based on the severity of the offence."
            typesJson={serviceTypesData["Assault"]}
          />
          <ServiceDescriptionSection
            header="Penalties for Assault"
            content={
              <div>
                <ul>
                  <li><strong>Fines:</strong> In some cases, minor assaults may result in fines rather than imprisonment.</li>
                  <li><strong>Imprisonment:</strong> For more serious offences, particularly those involving significant injury or aggravating factors, imprisonment is likely.</li>
                  <li><strong>Community Corrections Orders:</strong> For less severe offences, the court may impose a community corrections order (CCO), requiring the offender to perform community service, attend rehabilitation programs, or follow certain restrictions.</li>
                </ul>
              </div>
            }
          />
          <ServiceTypes
            header="Types of Property Damage"
            preamble="Property damage involves unlawfully damaging or destroying someone else's property. This can include vandalism, graffiti, and acts of destruction caused by negligence or recklessness. Property damage can be charged as either a minor or serious offence, depending on the extent of the damage and whether it was intentional."
            typesJson={serviceTypesData["Property Damage"]}
          />
          <ServiceDescriptionSection
            header="Penalties for Property Damage"
            content={
              <div>
                <div>The penalties for property damage depend on the value of the damaged property, whether the damage was intentional or reckless, and whether lives were endangered. The penalties may include:</div>
                <ul>
                  <li><strong>Fines:</strong> Minor property damage offences, like graffiti or low-value damage, may result in fines or clean-up orders.</li>
                  <li><strong>Community Corrections Orders (CCOs):</strong> Offenders may be sentenced to community service or other corrective measures.</li>
                  <li><strong>Imprisonment:</strong> Serious acts of property damage, especially those involving arson or aggravated criminal damage, can result in imprisonment for several years.</li>
                </ul>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="The Importance of Legal Representation"
            content="Being charged with assault or property damage can have significant consequences, including imprisonment, fines, and a criminal record that can affect your future opportunities. Having a qualified legal representative is crucial in ensuring your rights are protected, exploring possible defences, and seeking the best possible outcome in your case."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you are facing charges related to assault or property damage in Victoria, our experienced legal team can provide the support and representation you need. We offer confidential, professional advice to help you navigate the legal process and achieve the best possible outcome."
          />
        </div>
      </div>
    </div>
  );
};

export default AssaultAndPropertyDamage;
